exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".borderless th{border:none}ul.history{list-style:none}ul.history li{margin-left:-15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-69b35302!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/tickets/Tickets.vue
// module id = 593
// module chunks = 0